import React, { useState } from "react";
import GetLinks from "Constant/Header/Header";
import { Link } from "react-router-dom";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

const Navigation = ({ onHandleDrawer, isVisible }) => {
  const links = GetLinks();
  const [openMegaIndex, setOpenMegaIndex] = useState(null); // To track which mega menu is open

  const toggleMegaMenu = (index) => {
    // Toggle the current mega menu, close others
    if (openMegaIndex === index) {
      setOpenMegaIndex(null); // Collapse if already open
    } else {
      setOpenMegaIndex(index); // Open the clicked mega menu
    }
  };

  return (
    <ul
      className={`flex right-20 transition ease-in duration-300 $ gap-x-8 capitalize`}
    >
      {links &&
        links?.map(({ name, path, mega, pages }, index) =>
          mega ? (
            <li key={index} className="text-lg py-2 text-start relative group">
              <button className="w-full flex items-center justify-between hover:text-[#ccc]">
                {name}

                {openMegaIndex === index ? (
                  <CaretUp size={20} />
                ) : (
                  <CaretDown size={20} />
                )}
              </button>

              {/* Collapsible content */}
              <ul
                className={`my-2 flex flex-col gap-y-3 px-4 py-6 invisible select-none absolute left-0 w-[max-content] bg-white/30 text-white group-hover:opacity-[1] group-hover:visible group-hover:select-auto opacity-0 backdrop-blur-xl rounded-sm`}
              >
                {pages?.map(({ name, slug }, index) => (
                  <li key={index}>
                    <Link
                      className="text-base text-start hover:underline"
                      to={slug}
                      onClick={() => {
                        toggleMegaMenu();
                        onHandleDrawer();
                      }}
                    >
                      {name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ) : (
            <Link
              onClick={onHandleDrawer}
              className="text-lg py-2 hover:text-[#ccc]"
              key={index}
              to={path}
            >
              {name}
            </Link>
          )
        )}
    </ul>
  );
};

export default Navigation;
